import { render, staticRenderFns } from "./SettingsSync.vue?vue&type=template&id=467a0be9&scoped=true"
import script from "./SettingsSync.vue?vue&type=script&lang=js"
export * from "./SettingsSync.vue?vue&type=script&lang=js"
import style0 from "./SettingsSync.vue?vue&type=style&index=0&id=467a0be9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467a0be9",
  null
  
)

export default component.exports